import { useEffect, useState } from 'react';
import { EChartOption } from 'echarts/lib/echarts';

export default (func, params, dependencies) => {
  const [option, setOption] = useState<EChartOption>({});

  useEffect(() => {
    const newOption = func(params);
    setOption(newOption);
  }, [...dependencies]);
  return option;
};
